import * as Sentry from "@sentry/nextjs";

const env = process.env.VERCEL_ENV || process.env.NODE_ENV || "development";

function shouldLog(level: "debug" | "info" | "warning" | "error" | "exception") {
  if (env === "production") return true;
  // In development, only allow "debug", "error" and "exception"
  return level === "debug" || level === "error" || level === "exception";
}

export class Logger {
  static debug(message: string, context?: Record<string, any>) {
    if (shouldLog("debug")) {
      Sentry.captureMessage(message, {
        level: "debug",
        extra: { ...context, platform: "web UI" },
      });
    }
  }

  static info(message: string, context?: Record<string, any>) {
    if (shouldLog("info")) {
      Sentry.captureMessage(message, {
        level: "info",
        extra: { ...context, platform: "web UI" },
      });
    }
  }

  static warning(message: string, context?: Record<string, any>) {
    if (shouldLog("warning")) {
      Sentry.captureMessage(message, {
        level: "warning",
        extra: { ...context, platform: "web UI" },
      });
    }
  }

  static error(message: string, context?: Record<string, any>) {
    if (shouldLog("error")) {
      Sentry.captureMessage(message, {
        level: "error",
        extra: { ...context, platform: "web UI" },
      });
    }
  }

  static captureException(exception: Error | string, context?: Record<string, any>) {
    if (shouldLog("exception")) {
      Sentry.captureException(exception, {
        extra: { ...context, platform: "web UI" },
      });
    }
  }
}
